<template>
  <router-link v-on="$listeners" v-bind="linkProps" class="eb-button">
    <slot></slot>
  </router-link>
</template>

<script>
export default {
  name: 'EbLinkButton',
  props: {
    inline: Boolean,
    disabled: Boolean,
    to: {type: [String, Object]},
  },
  computed: {
    linkProps() {
      if (this.disabled) {
        return {
          'aria-disabled': true,
        }
      }
      return {to: this.to}
    },
  },
}
</script>
